<template>
    <div>
        <div
            :class="['sprite-' + timePartOfDay, 'sprite-' + statussCode]"
        >
        </div>
    </div>
</template>

<script>
  export default {
    name: "ForecastIcon",
    props: ['statussCode', 'timePartOfDay']
  }
</script>

<style lang="scss" scoped>
    @import "src/assets/scss/_variables";

    @import "/src/assets/scss/_weather-icons.scss";

    .sprite-day {
        background-image: url('../../assets/img/day-weather-icons.png');
        background-repeat: no-repeat;
        display: block;
        filter: grayscale(100%);
    }

    .sprite-night {
        background-image: url('../../assets/img/night-weather-icons.png');
        background-repeat: no-repeat;
        display: block;
        filter: grayscale(100%);
    }
</style>